export default {
  affiliate: {
    // Main navigation
    title: 'พันธมิตร',
    cantFindQuestion: 'ไม่พบคำถาม?',
    onlineService: 'บริการออนไลน์',
    dashboard: 'แดชบอร์ด',
    myRewards: 'รางวัลของฉัน',
    // My Price 页（照 Figma 重做）
    team: 'Team',
    myPrice: 'My Price',
    rule: 'Rule',
    checkOutRules: 'Check Out Our Rules',
    rewardsOverview: 'Rewards Overview',
    rewardAmount: 'Reward Amount',
    date: 'Date',
    selectDate: 'Select Date',
    commissionRewards: 'Commission Rewards',
    noReferralRewards: 'No referral rewards yet \nInvite friends to start earning rewards',
    noCommissionRewards: 'No commission rewards yet \nStart earning by inviting friends',
    inviteFriendsToEarnTitle: 'Invite Friends To Earn',
    moreFriendsMoreRewards: 'More friends, more rewards, unlimited earning potential !',
    inviteNow: 'Invite Now',
    invitationRewards: 'รางวัลการเชิญ',
    rules: 'กฎ',

    // Team Info
    teamData: 'ข้อมูลทีม',
    details: 'รายละเอียด',
    totalValidFriends: 'เพื่อนที่ถูกต้องทั้งหมด:',
    todayTotalWager: 'ยอดเดิมพันวันนี้:',
    rewards: 'รางวัล',

    // Commission rates
    inviteFriendsCommissionUpTo: 'ค่าคอมมิชชั่นการเชิญเพื่อนสูงสุด',
    expandTeamBonus: 'โบนัสขยายทีม',
    maxLevelCommission: 'ค่าคอมมิชชั่นระดับสูงสุด',
    inviteFriendsCommission: 'ค่าคอมมิชชั่นการเชิญเพื่อน',
    maxPerformanceCommission: 'ค่าคอมมิชชั่นผลงานสูงสุด',
    unlimitedAgent: 'ตัวแทนไม่จำกัด',
    unlimitedCommission: 'ค่าคอมมิชชั่นไม่จำกัด',
    commissionRate: 'อัตราค่าคอมมิชชั่น',

    // Team Invite Friends
    inviteFriendsToEarn: 'เชิญเพื่อนเพื่อรับรางวัล',
    link: 'ลิงก์',
    code: 'รหัส',
    inviteFriends: 'เชิญเพื่อน',
    share: 'แชร์',

    // Withdrawal Rewards
    totalCommission: 'Total Commission',
    claim: 'รับรางวัล',
    bettingBonus: 'Betting Bonus',
    depositBonus: 'Deposit Bonus',
    todayReceived: 'ได้รับวันนี้',

    // Live Rewards
    liveRewards: 'รางวัลสด',
    sendTotalCommission: 'ส่งค่าคอมมิชชั่นทั้งหมด',

    // Team Data Details
    totalRewardsReceived: 'Total Commission',
    todayInviteFriends: 'เชิญเพื่อนวันนี้',
    todayDepositFriends: 'เพื่อนฝากเงินวันนี้',
    depositFriends: 'เพื่อนฝากเงิน',
    validFriends: 'เพื่อนที่ถูกต้อง',

    // Dialogs
    howMakeFriendsSubordinates: 'วิธีทำให้เพื่อนเป็นผู้ใต้บังคับบัญชาของคุณ:',
    shareInvitationLink: 'แชร์ลิงก์เชิญของคุณเพื่อให้พวกเขาลงทะเบียน',
    shareInvitationCode: 'แชร์รหัสเชิญของคุณเพื่อให้พวกเขากรอกระหว่างการลงทะเบียน',
    shareQRCode: 'แชร์รหัส QR ของคุณเพื่อให้พวกเขาสแกนและลงทะเบียน',
    depositFriendsDescription: 'เมื่อเพื่อนผู้ใต้บังคับบัญชาของคุณฝากเงินสำเร็จ พวกเขาจะกลายเป็นเพื่อนที่ฝากเงิน',
    howMakeFriendsValidUsers: 'วิธีทำให้เพื่อนของคุณเป็นผู้ใช้ที่ถูกต้อง:',
    successfullyInviteFriends: 'เชิญเพื่อนสมัครสมาชิกสำเร็จ',
    cumulativeDepositsReach: 'ยอดฝากสะสมของพวกเขาถึง 10.00 USDT',
    cumulativeValidBetsReach: 'ยอดเดิมพันที่ถูกต้องสะสมของพวกเขาถึง 50.00 USDT',
    thenBecomeValidUsers: 'จากนั้นพวกเขาจะกลายเป็นผู้ใช้ที่ถูกต้อง',

    // Share Dialog
    shareTitle: 'แชร์',
    player: 'ผู้เล่น',
    saveImage: 'บันทึกรูปภาพ',
    saveImageSuccess: "บันทึกรูปภาพแล้ว",
    saveImageFailed: "บันทึกไม่สำเร็จ โปรดลองอีกครั้ง",
    copy: 'คัดลอก',
    copied: 'คัดลอกแล้ว!',

    // Received/Withdraw
    received: 'ได้รับ',
    withdraw: 'ถอน',
    history: 'ประวัติ',
    referralRewards: 'รางวัลการแนะนำ',
    commission: 'ค่าคอมมิชชั่น',
    depositRebate: 'ส่วนลดการฝาก',
    levelUpRewards: 'รางวัลการอัพเลเวล',
    loading: 'กำลังโหลด...',
    noMoreRecords: 'ไม่มีรายการเพิ่มเติม',
    loadMore: 'โหลดเพิ่มเติม',
    pending: 'รอดำเนินการ',
    paid: 'จ่ายแล้ว',
    rejected: 'ปฏิเสธ',
    unknown: 'ไม่ทราบ',
    upgradeReward: 'รางวัลการอัพเลเวล',
    cancelled: 'ยกเลิกแล้ว',
    receiving: 'กำลังรับ',
    failed: 'ไม่สำเร็จ',
    expired: 'หมดอายุ',

    // History Dialog
    pickDate: 'เลือกวันที่',
    select: 'เลือก',
    chooseBonus: 'เลือกโบนัส',
    all: 'ทั้งหมด',

    // Invitation Rewards Page
    inviteFriendToGet: 'เชิญเพื่อนเพื่อรับ',
    yourFriendGet: 'เพื่อนของคุณได้รับ',
    inviteFriendsEarnRewards: 'เชิญเพื่อนและรับรางวัล',
    dailyInvitations: 'การเชิญรายวัน',

    // Rules - How to earn
    howToEarnAffiliateRewards: 'วิธีรับรางวัลพันธมิตร?',
    shareToFriends: 'แชร์ให้เพื่อน',
    shareReferralLink: 'แชร์ลิงก์แนะนำ รหัส หรือ QR code ของคุณกับเพื่อนๆ',
    friendsSignUpDeposit: 'เพื่อนสมัครและฝากเงิน',
    inviteFriendsRegisterDeposit: 'เชิญเพื่อนสมัครสมาชิกที่ AFUN และทำการฝากเงินครั้งแรก',
    getUpTo: 'รับได้ถึง',
    earnBigRewards: 'รับรางวัลและค่าคอมมิชชั่นเมื่อเพื่อนเดิมพัน ฝากเงิน และไปถึง VIP',
    noticeEnsureCorrect: 'หมายเหตุ: ตรวจสอบให้แน่ใจว่าลิงก์เชิญ รหัส QR หรือรหัสถูกต้อง',

    // Rules - Commission Work
    howCommissionWork: 'ค่าคอมมิชชั่นทำงานอย่างไร?',
    agentRatingDescription: 'คำอธิบายการจัดอันดับตัวแทน',
    you: 'คุณ',
    commissionDescription: 'รับค่าคอมมิชชั่นจากการฝากเงินและการเดิมพันของเพื่อน B, C, D และต่อไป ดูตารางด้านขวาสำหรับอัตราค่าคอมมิชชั่น',
    claimConditions: 'เงื่อนไขการรับ',
    teamLevel: 'ระดับทีม',
    earnUpTo: "Earn up to",
    expandYourTeam: "ขยายทีมของคุณ",
    earnAnExtra: "รับเพิ่มเติม",
    upgradeAgentLevel: "อัปเกรดระดับตัวแทนของคุณ",
    todayValidFriends: "Today valid friends",
    inviteFriendsAndEarn: "INVITE FRIENDS AND EARN",
    joinUsGetCommission: "Join us and get more commission",
    shareLinkInviteDesc: "Share the link with your friends and invite them to register and deposit, you and your friend can get shared commissions.",
    totalSize: 'ขนาดรวม',
    teamWager: 'ยอดเดิมพันทีม',
    rebateRewardVary: 'รางวัลคืนเงินและรางวัลเติมเงินแตกต่างกันตามระดับทีมของคุณในวันนั้น',
    teamSizeDescription: 'ขนาดทีม: จำนวนผู้ใช้ที่ถูกต้องที่คุณมีในปัจจุบัน',
    teamBettingDescription: 'การเดิมพันของทีม: จำนวนการเดิมพันทั้งหมดที่ผู้ใต้บังคับบัญชาของคุณทำในหนึ่งวัน',
    teamCommissionTitle: 'TEAM COMMISSION\n\nEarn from every deposit and every bet across your network.',
    teamCommissionMainTitle: 'ค่าคอมมิชชั่นทีม',
    teamCommissionSubTitle: 'รับจากทุกการฝากเงินและ\nทุกการเดิมพันในเครือข่ายของคุณ',
    friendsBettingRebate: 'Friends betting rebate commission',
    commissionCalcEvery24h: 'The system calculates commissions every 24 hours.',
    earnCommissionWhenBet: 'You earn a commission when your friends or their friends place bets.',
    commissionSameIpRule: 'Commissions cannot be released to accounts that share the same IP address, device, or shared account, regardless of whether they are on public networks (such as schools, libraries, and offices) or private networks (such as homes and apartments). To receive commissions, the referred account must be on a unique IP address, not shared with other accounts on the platform.',
    commissionFormula: 'Commission = total team wager * 1% * commission rate.',
    commissionRangeDescription: 'You can receive a certain percentage of commission from all the wager and recharge amount made by A, B, C, D, E and F. Please refer to the following diagram for specific commission rates.',
    commissionSupportGames: 'Commission Support Games',

    // Rules - Invitation Rewards
    inviteFriendsBothReceive: 'เชิญเพื่อนและทั้งคู่จะได้รับรางวัล',
    inviteRegisterReceive: 'เชิญเพื่อนสมัครสมาชิกสำเร็จและรับ',
    friendDepositWagerUnlock: 'เมื่อเพื่อนของคุณฝาก 10.00 USDT และเดิมพัน 50.00 USDT คุณจะปลดล็อกรางวัล 3.00 USDT และเพื่อนของคุณจะได้รับ 2.00 USDT',

    // Team Data Dialog / Rewards 补充
    recentInviteFriends: 'เพื่อนที่เชิญล่าสุด',
    recentDepositFriends: 'เพื่อนฝากเงินล่าสุด',
    today: 'วันนี้',
    yesterday: 'เมื่อวาน',
    thisMonth: 'เดือนนี้',
    friendsData: 'ข้อมูลเพื่อน',
    joinDate: 'วันที่เข้าร่วม',
    search: 'ค้นหา',
    level: 'ระดับ',
    tier: 'ชั้น',
    affiliateTreasureBox: 'กล่องสมบัติพันธมิตร',
    referralRewardsDesc: 'เมื่อคุณเชิญเพื่อนมาลงทะเบียน ทั้งคุณและเพื่อนจะได้รับโบนัสมากมาย',
    commissionDesc: 'คุณและทีมของคุณร่วมมือกันบรรลุเป้าหมายและรับค่าคอมมิชชั่นมากมาย',
    affiliateTreasureBoxDesc: 'เชิญเพื่อนเพื่อรับโบนัสตามเป้าหมาย',
  }
};
